export const globalMinTime = "07:30";
export const globalMaxTime = "20:00";

export const MonthsName = ["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"];
export const MonthsShortame = ["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"];

export const WeekdaysName = ["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"];

export const WeekdaysShortname = ["Dom","Lun","Mar","Mer","Gio","Ven","Sab"];
